<template>
  <div class="fields__field fields__field--single-select" :class="{ '-error': error && !value }">
    <div class="field__label">
      <label class="control-label" :for="identifier" :class="{'bold': bold}">{{ label }}</label>
    </div>
    <div class="field__input icon-caret-down-after">
      <div class="select__select">
        <div class="select__fake-select">
          <span v-if="!value">- Bitte wählen -</span>
          <span v-else>{{ value }}</span>
        </div>
        <div class="select__orig-select">
          <select :name="identifier" :id="identifier" :class="{ '-filled': value }" @change="$emit('input', $event.target.value)">
            <option value=""></option>
            <option v-for="(option, index) in options" :key="index" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['identifier', 'value', 'error', 'label', 'bold', 'options']
}
</script>
